






















import { Component, Vue } from 'vue-property-decorator'
import NavBar from '@/components/home/NavBar.vue'
import HeaderBar from '@/components/home/HeaderBar.vue'
import Breadcrumb from '@/components/common/Breadcrumb.vue'
import { getUserInfo } from '@/request/apis/UserRequest'
import { UserInfo } from '@/types/User'

@Component({
  components: {
    HeaderBar,
    NavBar,
    Breadcrumb
  }
})
export default class Container extends Vue {
  mounted () {
    // 获取一次用户信息, 判断是否登录
    getUserInfo(null, { showSuccessMsg: false }).start().then((userInfo: UserInfo) => {
      this.$store.dispatch('updateUserInfo', userInfo)
    })
  }
}
